<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div class="login d-flex flex-column justify-center align-center">
      <v-card
        class="d-flex flex-column justify-center align-center pa-6 py-10"
        elevation="0"
      >
        <img :src="logoUrl" style="width: 150px" />
        <p class="headline text-center mt-2">Update your Email Address</p>
        <v-form class="mx-5 my-5" @submit.prevent="updateEmailSubmit">
          <v-text-field
            v-model="password"
            name="Password"
            label="Enter your password to continue"
            type="password"
            hide-details
            background-color="grey lighten-3"
            solo
            dense
            flat
            required
          ></v-text-field>
          <v-btn
            class="mt-4"
            block
            rounded
            depressed
            color="primary"
            type="updateEmailSubmit"
            >Submit</v-btn
          >
          <div class="link mt-8">
            <a class="text-tiny" @click="redirectLogin">Login Here</a>
          </div>
          <div class="link">
            <a
              class="text-tiny"
              style="font-style: italic"
              @click="redirectSignUp"
              >Don't have an account? Sign Up Here</a
            >
          </div>
        </v-form>
      </v-card>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackMessage }}
      <v-btn color="primary" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['username'],
  data() {
    return {
      password: '',
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`,
      version: process.env.VUE_APP_VERSION,
      snackMessage: '',
      snackbar: false,
      timeout: 5000,
      loading: false
    }
  },
  methods: {
    ...mapActions('auth', ['updateEmailAction']),
    async updateEmailSubmit() {
      this.loading = true
      return this.updateEmailAction({
        password: this.password,
        username: this.username
      })
        .then(async (response) => {
          this.loading = false
          if (response) {
            this.$root
              .$confirm({
                title: 'Update Email Address',
                message: `Your email address has been updated.`,
                reconfirmOnly: true,
                confirmText: 'Login Here'
              })
              .then(() => {
                this.$router.push(`/login`)
              })
            // this.snackbar = true
            // this.snackMessage = 'A password reset link has been sent to your email.'
          } else {
            this.loading = false
            this.snackbar = true
            this.snackMessage = response.message
          }
        })
        .catch((err) => {
          this.loading = false
          this.snackbar = true
          this.snackMessage = err
        })
    },
    redirectSignUp() {
      this.$router.replace('/signup')
    },
    redirectLogin() {
      this.$router.replace('/login')
    }
  },
  computed: {
    logoUrl() {
      return `${process.env.BASE_URL}images/logo_text_bottom.png`
    }
  }
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
.login {
  /*background-image: `url(${process.env.BASE_URL}images/cover_img_1.jpg)`;*/
  height: 100%;
}
.v-card {
  border-radius: 12px !important;
}
.v-form {
  width: 20vw;
}
.link {
  text-align: center;
}
.link a {
  text-decoration: none;
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
}
.subtitle-2 {
  letter-spacing: 3px;
}
</style>
